export default [
  'daniel.garrido@foodforjoe.es',
  'diego@foodforjoe.es',
  'tania@foodforjoe.es',
  'jonathan@foodforjoe.com',
  'daniel@wedo-solutions.com',
  'office@wedo-solutions.com',
];
